import React from 'react'
import Create from '../crud/create'
import fields from './create-fields'
import menuItems from './menuItems'

const defaultResource = {
  member_type: 'user'
}

const CreateUserMembership = props => {
  return (
    <Create
// @ts-ignore
      title='Create Individual Membership'
      fields={fields}
      apiPath='admin/memberships'
      successRedirectPath={resource => `/membership/user-memberships/${resource.id}/edit`}
      buildMenuItems={menuItems}
      resource={defaultResource}
    />
  )
}

export default CreateUserMembership
